import { Delta } from 'quill/core';
import type { ComponentProps } from 'react';
import React from 'react';
import * as styles from './ProductUpdateCard.module.scss';
import { useAppDispatch } from '../app/redux/useAppSelector';
import SVGIcon from '../components/SVGIcon';
import deltaToText from '../editor/utils/deltaToText';
import giftIcon from '../icons/non-prefilled/16x16/gift.svg';
import ProductUpdateModal from '../post/modalView/ProductUpdateModal';
import { UIActions } from '../ui/uiSlice';
import { getFirstLineFromDelta } from '../utils/deltaHelpers';

type ProductUpdateCardProps = Omit<
  ComponentProps<typeof ProductUpdateModal>,
  'close'
>;

const ProductUpdateCard = ({
  banner,
  content,
  publishedDate,
  newTabTo,
}: ProductUpdateCardProps) => {
  const firstLine = getFirstLineFromDelta(new Delta(content));
  const title = firstLine ? deltaToText(firstLine) : 'Untitled';

  const dispatch = useAppDispatch();

  return (
    <button
      type="button"
      className={styles.card}
      onClick={() => {
        dispatch(
          UIActions.openModal(ProductUpdateModal, {
            banner,
            content,
            publishedDate,
            newTabTo,
          }),
        );
      }}
    >
      <img className={styles.banner} src={banner} alt="" />
      <SVGIcon className={styles.badge}>{giftIcon}</SVGIcon>
      <div className={styles.title}>{title}</div>
    </button>
  );
};

export default ProductUpdateCard;
